import AuthWrapper from "./auth.builder";
import authBuilderConfig from "./auth.builder.config"

export default {
  config: authBuilderConfig,
  component: AuthWrapper,
};
